/* Zombie: Home "Where can I find Zombie" map teaser — a light SVG motion layer
   over the existing illustration (3 Oct 2026). The artwork is a single raster
   (no vector original), so instead of a Lottie rebuild this draws on top of it:
   YOU HERE pulses, a pink trail runs the dashed route, two horde dots give chase
   and get stopped at the checkpoint, the SAFE HOUSE pin pulses. ~6s loop, ~3KB,
   no network requests. Only runs when the section still shows the map artwork
   (the route is traced to that image), never with reduced motion, and pauses
   while scrolled out of view. The real store locator (Storemapper app, since 9 Oct 2026) is on Where to Buy. */
(function () {
  var LOOP = '6s';
  var ROUTE = 'M262,552 C320,525 400,520 432,598 C440,640 448,690 500,710 C560,725 610,740 660,772 C720,805 800,800 835,760 C860,720 835,640 828,580 C824,540 832,512 852,502 C890,482 935,495 948,545 C962,620 975,720 998,828';

  function anim(attr, values, keyTimes, extra) {
    return '<animate attributeName="' + attr + '" values="' + values + '" keyTimes="' + keyTimes + '" dur="' + LOOP + '" repeatCount="indefinite"' + (extra || '') + '/>';
  }
  function mover(id, points, times, r) {
    return '<g class="zombie-map-fx__dot">' +
      '<circle r="' + r + '" fill="#000"/>' +
      '<animateMotion dur="' + LOOP + '" repeatCount="indefinite" calcMode="linear" keyPoints="' + points + '" keyTimes="' + times + '"><mpath href="#' + id + '"/></animateMotion>' +
      '</g>';
  }

  function build(uid) {
    var id = 'zombie-map-route-' + uid;
    return '<svg class="zombie-map-fx" viewBox="0 0 1254 1254" preserveAspectRatio="xMidYMid slice" aria-hidden="true" focusable="false">' +
      '<path id="' + id + '" d="' + ROUTE + '" fill="none" stroke="none"/>' +
      /* trail: multiply turns the white route band pink and leaves the black dashes black */
      '<path d="' + ROUTE + '" class="zombie-map-fx__trail" pathLength="1" stroke-dasharray="1 1">' +
        anim('stroke-dashoffset', '1;1;0;0', '0;0.1;0.78;1') +
        anim('opacity', '1;1;1;0;0', '0;0.8;0.86;0.96;1') +
      '</path>' +
      /* YOU HERE: ground ring spreads as the run starts */
      '<ellipse cx="205" cy="600" class="zombie-map-fx__ring">' +
        anim('rx', '40;40;100;100', '0;0.02;0.2;1') + anim('ry', '14;14;36;36', '0;0.02;0.2;1') +
        anim('opacity', '0;0.9;0;0', '0;0.02;0.2;1') +
      '</ellipse>' +
      /* the horde gives chase, then gives up at the checkpoint */
      '<g class="zombie-map-fx__horde">' +
        mover(id, '0;0;0.2;0.2', '0;0.2;0.46;1', 13) + anim('opacity', '0;0;1;1;0;0', '0;0.18;0.22;0.44;0.52;1') +
      '</g>' +
      '<g class="zombie-map-fx__horde">' +
        mover(id, '0;0;0.17;0.17', '0;0.26;0.5;1', 11) + anim('opacity', '0;0;1;1;0;0', '0;0.24;0.28;0.48;0.56;1') +
      '</g>' +
      /* the runner */
      '<g class="zombie-map-fx__runner">' +
        '<circle r="28" fill="#fff"/><circle r="18" fill="#FF0ADC" stroke="#000" stroke-width="8"/>' +
        '<animateMotion dur="' + LOOP + '" repeatCount="indefinite" calcMode="linear" keyPoints="0;0;1;1" keyTimes="0;0.1;0.78;1"><mpath href="#' + id + '"/></animateMotion>' +
        anim('opacity', '0;1;1;0;0', '0;0.08;0.8;0.88;1') +
      '</g>' +
      /* SAFE HOUSE: pin pulses when the runner arrives */
      '<circle cx="1085" cy="748" class="zombie-map-fx__ring">' +
        anim('r', '48;48;48;110;110', '0;0.76;0.78;0.98;1') +
        anim('opacity', '0;0;0.9;0;0', '0;0.76;0.78;0.98;1') +
      '</circle>' +
      '<circle cx="1085" cy="748" class="zombie-map-fx__ring">' +
        anim('r', '48;48;48;110;110', '0;0.84;0.86;1;1') +
        anim('opacity', '0;0;0.7;0;0', '0;0.84;0.86;1;1') +
      '</circle>' +
    '</svg>';
  }

  function init() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var figures = document.querySelectorAll('[id$="__zombie-locator"] figure.media');
    Array.prototype.forEach.call(figures, function (figure, i) {
      var img = figure.querySelector('img');
      if (!img || figure.querySelector('.zombie-map-fx')) return;
      if (!/store-locator-map/.test(img.currentSrc || img.src || '')) return;
      figure.insertAdjacentHTML('beforeend', build(i));
      var svg = figure.querySelector('.zombie-map-fx');
      if (!svg || typeof svg.pauseAnimations !== 'function') return;
      if ('IntersectionObserver' in window) {
        svg.pauseAnimations();
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { e.isIntersecting ? svg.unpauseAnimations() : svg.pauseAnimations(); });
        }, { rootMargin: '100px 0px' }).observe(figure);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
